import { IconProps } from ".";
import { coalColor } from "../../../styles/theme";

export const CheckIcon = ({
  size = 16,
  color = coalColor,
  className,
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M26 8C16 14 15 22.5 13 24C11 25.5 8 19 6 16"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};
